import { isSiteRegionCode } from './regions';

export function isHttpsUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && Boolean(url.hostname);
  } catch {
    return false;
  }
}

export function isInternalRoute(value: string): boolean {
  return value.startsWith('/') && !value.startsWith('//') && !/\s/.test(value);
}

export function hasInternalRouteRegionPrefix(value: string): boolean {
  const routePrefix = value.trim().match(/^\/([^/?#]+)(?=[/?#]|$)/);
  return routePrefix ? isSiteRegionCode(routePrefix[1].toUpperCase()) : false;
}
